module.exports = __webpack_public_path__ + "img/inggris1.951e6950.jpeg";